import '../CsvJsonInfoPages.scss';


function FuturePrices() {

 const data = [
    { field: 1, description: 'CAP Vehicle Code' },
    { field: 2, description: 'CAP Vehicle Identification Number' },
    { field: 3, description: 'Registration Year (Blank in New Monitor)' },
    { field: 4, description: 'Registration Letter (Blank in New Monitor)' },
    { field: 5, description: 'Mileage/Kms 1 (NB) Mileage applicable to Cars and LCV. Km applicable to HGV on all values' },
    { field: 6, description: 'Periods 1st Mileage/Kms Values' },
    { field: 7, description: 'Mileage/Kms 2' },
    { field: 8, description: 'Periods 2nd Mileage/Kms Values' },
    { field: 9, description: 'Mileage/Kms 3' },
    { field: 10, description: 'Periods 3rd Mileage/Kms Values' },
    { field: 11, description: 'Mileage/Kms 4' },
    { field: 12, description: 'Periods 4th Mileage/Kms Values' },
    { field: 13, description: 'Mileage/Kms 5' },
    { field: 14, description: 'Periods 5th Mileage/Kms Values' },
    { field: 15, description: 'Mileage/Kms 6' },
    { field: 16, description: 'Periods 6th Mileage/Kms Values' },
    { field: 17, description: 'Mileage/Kms 7' },
    { field: 18, description: 'Periods 7th Mileage/Kms Values' },
    { field: 19, description: 'Mileage/Kms 8' },
    { field: 20, description: 'Periods 8th Mileage/Kms Values' },
    { field: 21, description: 'Mileage/Kms 9' },
    { field: 22, description: 'Periods 9th Mileage/Kms Values' },
    { field: 23, description: 'Mileage/Kms 10' },
    { field: 24, description: 'Periods 10th Mileage/Kms Values' },
    { field: 25, description: 'Mileage/Kms 11' },
    { field: 26, description: 'Periods 11th Mileage/Kms Values' },
    { field: 27, description: 'Mileage/Kms 12' },
    { field: 28, description: 'Periods 12th Mileage/Kms Values' },
    { field: 29, description: 'Mileage/Kms 13' },
    { field: 30, description: 'Periods 13th Mileage/Kms Values' },
    { field: 31, description: 'Mileage/Kms 14' },
    { field: 32, description: 'Periods 14th Mileage/Kms Values' },
    { field: 33, description: 'Mileage/Kms 15' },
    { field: 34, description: 'Periods 15th Mileage/Kms Values' },
    { field: 35, description: 'Mileage/Kms 16' },
    { field: 36, description: 'Periods 16th Mileage/Kms Values' },
    { field: 37, description: 'Mileage/Kms 17' },
    { field: 38, description: 'Periods 17th Mileage/Kms Values' },
    { field: 39, description: 'Mileage/Kms 18' },
    { field: 40, description: 'Periods 18th Mileage/Kms Values' },
    { field: 41, description: 'Mileage/Kms 19' },
    { field: 42, description: 'Periods 19th Mileage/Kms Values' },
    { field: 43, description: 'Mileage/Kms 20' },
    { field: 44, description: 'Periods 20th Mileage/Kms Values' },
    { field: 45, description: 'New Vehicle Price (##########.####) (Blank in Used Monitor)' },
    { field: 46, description: 'Date of last new price change (ddmmyyyy) (Blank in Used Monitor)' },
  ];

    return (
        <div className='csv-json-info-pages-container'>
            <h1>Future Values - Future Prices</h1>
            <p>Provides future residual valuations for new and used vehicles (CAP Monitor).
                <b>File Naming Convention</b>
                The &lt;FILENAME&gt; is dependant on the product being produced as follows.
            </p>

            <b>New Monitor</b>
            <p>CPRRVN.??? CARS<br />
                LPRRVN.??? LIGHT COMMERCIALS<br />
                HPRRVN.??? HEAVY COMMERCIALS<br />
                BPRRVN.??? BIKES
            </p>

            <b>Used Monitor</b>
            <p>CPRRVU.??? CARS<br />
                LPRRVU.??? LIGHT COMMERCIALS<br />
                HPRRVU.??? HEAVY COMMERCIALS<br />
                BPRRVU.??? BIKES<br /><br />

                The 14 Periods Covered 6, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78 and 84 Months.<br />
                NOTE : Not all of the periods may be used.
            </p>

             <table>
                    <thead>
                        <tr>
                            <th>Field</th>
                            <th>DATA</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index}>
                                <td>{item.field}</td>
                                <td>{item.description}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

        </div>
    );
}

export default FuturePrices;
